import React from 'react';
import Box from '@mui/material/Box';
import { DialogContentProps } from '../types';

const ConfirmationApproveForClientsOrDraft = ({ customMessage }: DialogContentProps) => (
  <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <span>{customMessage}</span>
  </Box>
);

export default ConfirmationApproveForClientsOrDraft;
